const refreshChatEvent = new Event("refresh-chat-event");

/*$('.side-menu').metisMenu({
  preventDefault: true
 });*/

function showLoader() {
  $(".loader").css("display", "flex");
}

function hideLoader() {
  setTimeout(() => {
    $(".loader").css("display", "none");
  }, 200);
}

function toggleSideMenu() {
  $(".sidebar").toggleClass("toggled");
  $(".mobile-overlay").toggleClass("hide");
  // $(".mobile-overlay").toggle(200);
}

function toggleMobileOverlay() {
  $(".sidebar").toggleClass("toggled");
  $(".mobile-overlay").toggleClass("hide");
  // $(".mobile-overlay").toggle(200);
}

function collapseSidebarButton() {
  $(this).toggleClass("toggled");
  $(".sidebar").toggleClass("desk-collapse");
  $(".collapse-sidebar-button span").toggleClass("hide");
  $(".cpage-link").parent("li").toggleClass("hide");
  $(".main-content").toggleClass("full-width");
  $(".collapse-sidebar-button i").toggleClass("fa-chevron-double-right");
  $('div:not(.desk-collapse) [data-toggle="sidebar-tooltip"]').tooltip(
    "disable"
  );
  setTimeout(() => {
    $('div.desk-collapse [data-toggle="sidebar-tooltip"]').tooltip("enable");
  }, 300);
  reloadMenu();
}

// $(".collapse-sidebar-button").click(function(event) {

// });

function jsColor() {
  $("#colorpicker").colorpicker();
}

function loadJsColor(setValElem, fromValElem) {
  setTimeout(() => {
    $(setValElem).jscolor.fromString($(fromValElem).val());
  }, 1000);
}
var _URL = window.URL || window.webkitURL;

function Filevalidation(elem) {
  const fi = document.getElementById(elem);
  var file, img;
  if ((file = fi.files[0])) {
    img = new Image();
    img.onload = function () {
      // alert(this.width + " " + this.height);
    };
    img.onerror = function () {
      alert("not a valid file: " + file.type);
    };
    img.src = _URL.createObjectURL(file);
  }
}

function triggerColorPickerClick() {
  jscolor.init();

  setTimeout(() => {
    $("#val1").focus();
  }, 200);
  setTimeout(() => {
    $("#val1").blur();
  }, 210);
}

function loadTableData(tableClass, extras = null) {
  if (tableClass == ".jobs-data-table") {
    tableData = $(tableClass).DataTable({
      destroy: true,
      responsive: true,
      searching: false,
      info: false,
      paging: false,
      initComplete: function (settings, json) {
        // remove initial widths from datatable, after load

        let table = window.document.getElementsByClassName("jobs-data-table");
        Array.from(table).forEach((el) => {
          el.style.removeProperty("width");
        });

        let header = window.document.getElementsByClassName(
          "dataTables_scrollHeadInner"
        );
        Array.from(header).forEach((el) => {
          el.style.removeProperty("width");
        });
      },

      lengthChange: false,
      order: [extras],
      scrollY: window.innerHeight - 300,
      scrollX: true,
      scrollCollapse: true,
      columnDefs: [
        {
          targets: -1,
          orderable: false,
        },
      ],
    });
  } else if (tableClass == ".union-local-data-table") {
    $(tableClass).DataTable({
      destroy: true,
      searching: false,
      info: false,
      lengthChange: false,
      pageLength: 50,
      columnDefs: [
        {
          targets: -1,
          orderable: false,
        },
        // , {
        //   type: 'currency',
        //   targets: 1
        // }
      ],
      order: [[1, "desc"]],
    });
  } else if (tableClass == ".audit-trail-data-table") {
    $(tableClass).DataTable({
      destroy: true,
      searching: false,
      info: false,
      lengthChange: false,
      pageLength: 50,
      columnDefs: [
        {
          targets: -1,
          orderable: false,
        },
      ],
      order: [[0, "desc"]],
    });
  } else {
    $(tableClass).DataTable({
      destroy: true,
      searching: false,
      info: false,
      lengthChange: false,
      pageLength: 50,
      columnDefs: [
        {
          targets: -1,
          orderable: false,
        },
      ],
    });
  }
  $(".paginate_button").click(function () {
    loadTooltip();
  });
}

function clearDatatable(tableClass) {
  $(tableClass).DataTable().clear().destroy();
}

function destroyUpdateDataTable(tableClass) {
  $(tableClass).trigger("destroy");
}

function updateDatatable(tableClass) {
  // $(tableClass).trigger("updateAll");
  $(tableClass)
    .tablesorter({
      // theme: "bootstrap",
      // theme: 'jui',
      widgets: ["zebra", "staticRow", "scroller"],
      // third click on the header will reset column to default - unsorted
      sortReset: true,
      // Resets the sort direction so that clicking on an unsorted column will sort in the sortInitialOrder direction.
      sortRestart: true,
      widgetOptions: {
        cssAsc: "tablesorter-headerAsc", // tablesorter-headerAsc
        cssDesc: "tablesorter-headerDesc", // tablesorter-headerDesc
        cssHeader: "tablesorter-header", // tablesorter-header
        cssNone: "tablesorter-headerUnSorted", // tablesorter-headerUnSorted
        scroller_height: window.innerHeight - 250,
        // scroll tbody to top after sorting
        scroller_upAfterSort: true,
        // pop table header into view while scrolling up the page
        scroller_jumpToHeader: true,
        // In tablesorter v2.19.0 the scroll bar width is auto-detected
        // add a value here to override the auto-detected setting
        scroller_barWidth: null,
        scroller_addFixedOverlay: true,
        // scroll_idPrefix was removed in v2.18.0
        // scroller_idPrefix : 's_'
      },
    })
    .on("scrollerComplete", function () {
      const header = window.document.getElementsByClassName(
        "tablesorter-scroller-header"
      );

      const table = window.document.getElementsByClassName(
        "tablesorter-scroller-table"
      );

      Array.from(header).forEach((el) => {
        el.style.removeProperty("width");
      });
      Array.from(table).forEach((el) => {
        el.style.removeProperty("width");
      });
    });
}

function sortInvoiceData(obj, field, type) {
  $(obj).val(field + ", " + type);
  $(obj).focus();
  $(obj).blur();
}

function destroyDataTable(tableClass) {
  $(tableClass).DataTable().destroy();
}

function reloadDataTable(tableClass, extras = '') {
  setTimeout(() => {
    destroyDataTable(tableClass)
    loadTableData(tableClass, extras);
  }, 1)
}

function loadTooltip() {
  $('[data-toggle="tooltip"]').tooltip();
}

function closeModal(id) {
  $("#task-code").modal("hide");
}

function scrollToBottom(id) {
  const element = document.getElementById(id);
  element.scrollTop = element.scrollHeight - element.clientHeight;
}

function enableDisableSelect2(obj, status = true) {
  setTimeout(() => {
    loadSelect2(obj, status);
  }, 200);
}

$(function () {
  $('[data-toggle="tooltip"]').tooltip();
});

function reloadMenu() {
  setTimeout(() => {
    var path = window.location.href;
    $(".sidebar-nav > ul > li > a").each(function () {
      if (this.href == path || path.startsWith(this.href)) {
        $(this)
          .parents("li")
          .siblings("li")
          .find(".sub-menu")
          .children("li")
          .removeClass("current-page");
        $(this).parents("li").siblings("li").removeClass("show");
        $(this).parents("li").removeClass("show");
        $(this)
          .parents("li")
          .find(".sub-menu")
          .children("li")
          .removeClass("current-page");
        setTimeout(() => {
          $(this).parents("li").addClass("current-page");
          $(this).parents("li").siblings("li").removeClass("current-page");
        }, 50);
      }
    });

    $(".sidebar-nav > ul > li .sub-menu a").each(function () {
      if (this.href == path || path.startsWith(this.href)) {
        if (!$(this).parents("li").hasClass("hide")) {
          $(this).parents("li").addClass("current-page");
          $(this).parents("li").siblings("li").removeClass("current-page");
          // $(this).parents('.sub-menu').parents('li').addClass('current-page');
          $(this).parents(".sub-menu").parents("li").addClass("show");
          $(this)
            .parents(".sub-menu")
            .parents("li")
            .siblings("li")
            .removeClass("current-page");
        }
      }
    });
  }, 10);
  $(".sidebar").toggleClass("toggled");
  $(".mobile-overlay").toggleClass("hide");
  $(".mobile-overlay").toggle(200);
}

function reloadLinkMenu(className = "") {
  setTimeout(() => {
    $(".sidebar-nav > ul > li > a" + className).each(function () {
      if (this.href == "javascript:void(0);") {
        $(this)
          .parents("li")
          .siblings("li")
          .find(".sub-menu")
          .children("li")
          .removeClass("current-page");
        // $(this).parents('li').siblings('li').removeClass('show');
        // $(this).parents('li').removeClass('show');
        $(this)
          .parents("li")
          .find(".sub-menu")
          .children("li")
          .removeClass("current-page");
        setTimeout(() => {
          $(this).parents("li").addClass("current-page");
          $(this).parents("li").siblings("li").removeClass("current-page");
        }, 50);
      }
    });
    // $('.sidebar-nav > ul > li .sub-menu a').each(function () {
    //   if (this.href == "javascript:void(0);") {
    //     if (!$(this).parents('li').hasClass('hide')) {
    //       $(this).parents('li').addClass('current-page');
    //       $(this).parents('li').siblings('li').removeClass('current-page');
    //       // $(this).parents('.sub-menu').parents('li').addClass('current-page');
    //       $(this).parents('.sub-menu').parents('li').addClass('show');
    //       $(this).parents('.sub-menu').parents('li').siblings('li').removeClass('current-page');
    //     }
    //   }
    // });
  }, 10);
  $(".sidebar").toggleClass("toggled");
  $(".mobile-overlay").toggleClass("hide");
  $(".mobile-overlay").toggle(200);
}

function successToast(msg) {
  iziToast.success({
    backgroundColor: "#5D7DE7",
    messageColor: "#fff",
    titleColor: "#fff",
    icon: "fa fa-check",
    iconColor: "#fff",
    transitionIn: "bounceInRight",
    title: "Success!",
    message: "" + msg,
  });
}

function dangerToast(msg) {
  iziToast.error({
    timeout: 6000,
    backgroundColor: "#BC5459",
    messageColor: "#fff",
    titleColor: "#fff",
    icon: "fa fa-ban",
    iconColor: "#fff",
    transitionIn: "bounceInRight",
    title: "Error!",
    message: "" + msg,
  });
}

function warningToast(msg) {
  iziToast.warning({
    message: msg,
    position: "topRight",
    backgroundColor: "#FAAF00",
    iconColor: "#ffffff",
    messageColor: "#fff",
    theme: "dark",
    messageSize: "16px",
    class: "notificationMsg",
  });
}

$("#success").click(function (event) {
  iziToast.success({
    message: "Job successfully submitted to accounting!",
    position: "topRight",
    backgroundColor: "#63A819",
    iconColor: "#ffffff",
    messageColor: "#fff",
    theme: "dark",
    messageSize: "16px",
    class: "notificationMsg",
  });
});

// MSG Error
$("#danger").click(function (event) {
  iziToast.error({
    message: "Job not submitted",
    position: "topRight",
    backgroundColor: "#DB4B39",
    iconColor: "#ffffff",
    messageColor: "#fff",
    theme: "dark",
    messageSize: "16px",
    class: "notificationMsg",
  });
});

// MSG Warning
$("#warning").click(function (event) {
  iziToast.warning({
    message: "Please submit job",
    position: "topRight",
    backgroundColor: "#FAAF00",
    iconColor: "#ffffff",
    messageColor: "#fff",
    theme: "dark",
    messageSize: "16px",
    class: "notificationMsg",
  });
});

$(window).scroll(function () {
  if ($(this).scrollTop() > 50) {
    $(".setting .nav").addClass("fixed");
    $(".jobs-tab .nav").addClass("fixed");
    $(".jobs-detail .action-form").addClass("fixed");
  } else {
    $(".setting .nav").removeClass("fixed");
    $(".jobs-tab .nav").removeClass("fixed");
    $(".jobs-detail .action-form").addClass("fixed");
  }
});


function toggleAccordion(id) {
  console.log('id', id);
  $("#toggle-row-" + id).trigger('click')
}

function toggleAccordion1(id) {
  $("#toggle-row1-" + id).trigger('click')

}

function loadInvoiceToggle() {
  var dataAttr = $(".invoicing-table table .header:first .toggle-icon").data(
    "id"
  );
  $(".invoicing-table table .header")
    .nextAll(".content" + dataAttr)
    .show();
  $(".invoicing-table table .header:first .toggle-icon").addClass("minus");
  $(".invoicing-table table #content" + dataAttr + " .toggle-icon1").addClass(
    "minus"
  );
  $(".toggle-icon").on("click", function (event) {
    var contentId = $(this).data("id");
    $(this).toggleClass("minus");
    if ($(this).hasClass("minus")) {
      $(
        ".invoicing-table table #content" + contentId + " .toggle-icon1"
      ).addClass("minus");
      $(this)
        .parents(".header")
        .nextAll(".content" + contentId)
        .fadeIn(200);
    } else {
      $(
        ".invoicing-table table #content" + contentId + " .toggle-icon1"
      ).removeClass("minus");
      $(this)
        .parents(".header")
        .nextAll(".content" + contentId)
        .fadeOut(200);
    }
  });
  $(".toggle-icon1").on("click", function (event) {
    var contentId = $(this).data("id");
    $(this)
      .parents(".content" + contentId)
      .next(".content" + contentId)
      .fadeToggle(200);
    $(this).toggleClass("minus");
  });
}

function triggerUpdateAll() {
  setTimeout(() => {
    $(".jobs-invoice-data-table").trigger("update");
  }, 200);
}

function setInvoiceJobId(dataId) {
  $(".invoiceJobId").val(dataId);
  $(".invoiceJobId").focus();
  $(".invoiceJobId").blur();
}

function setChatJobId(dataId) {
  $(".chatJobId").val(dataId);
  $(".chatJobId").focus();
  $(".chatJobId").blur();
}

function setJobId(dataId) {
  $(".jobLinkId").val(dataId);
  $(".jobLinkId").focus();
  $(".jobLinkId").blur();
}

$(function ($) {
  $(".toggle-icon").click(function (event) {
    $(this).parents(".header").nextAll(".content").fadeToggle(200);
    $(this).toggleClass("minus");
  });
});

function loadScroller(className = "") {
  if (className != "") {
    $(className).scrollbar();
  } else {
    $(".scrollbar").scrollbar();
  }
}

/**
 * Load Select2 jQuery Plugin
 * 
 * Angular 10 Upgrade - Modified by Mihir
 * Date: May 7, 2026
 * 
 * Changes Made:
 * - ADDED: $(el).removeAttr("aria-hidden") after each Select2 initialization
 * 
 * BEFORE (Angular 9):
 * Select2 was initialized without removing aria-hidden attribute
 * 
 * AFTER (Angular 10):
 * Remove aria-hidden attribute to fix accessibility warning
 * 
 * Reason for Change:
 * Angular 10 has stricter accessibility checks (WCAG compliance).
 * Select2 adds aria-hidden="true" to the original <select> element,
 * but the element can still receive focus, which violates accessibility guidelines.
 * Screen readers cannot access focused elements marked as hidden.
 * 
 * Error Fixed:
 * "Blocked aria-hidden on an element because its descendant retained focus"
 * 
 * Lines Modified: Added removeAttr after each .select2() initialization
 */
function loadSelect2(obj = null, status = false) {
  if (obj != null) {
    $(obj).each(function (i, el) {
      if (!$(el).hasClass("select2-hidden-accessible")) {
        $(el)
          .select2({
            selectOnClose: true,
            sorter: (data) =>
              data.sort((a, b) =>
                a.id != "null" &&
                a.id != "" &&
                a.id != undefined &&
                b.id != "null" &&
                b.id != "" &&
                b.id != undefined
                  ? a.text.localeCompare(b.text)
                  : 0
              ),
          })
          .on("select2:select", function (e) {
            $(this).attr("data-id", $(this).val());
            let input = $(this).parent("div").find("input");

            $(input).val($(this).val()).focus().blur();
            $(this).focus();

            closeSelect2OpenContainer();
          });
      }

      $(el).select2("enable", [status]);
    });
  } else {
    $("select.select2").each(function (i, el) {
      if (
        !$(el).hasClass("select2-hidden-accessible") &&
        $(el).hasClass("select2-only-ui")
      ) {
        $(el)
          .select2({
            selectOnClose: true,
            allowHtml: true,
          })
          .on("select2:select", function (e) {
            $(this).attr("data-id", $(this).val());
            let input = $(this).parent("div").find("input");

            $(input).val($(this).val()).focus().blur();
            $(this).focus();

            closeSelect2OpenContainer();
          });
      } else if (!$(el).hasClass("select2-hidden-accessible")) {
        $(el)
          .select2({
            selectOnClose: true,
            allowHtml: true,
            sorter: (data) =>
              data.sort((a, b) =>
                a.id != null &&
                a.id != "" &&
                a.id != undefined &&
                b.id != "null" &&
                b.id != "" &&
                b.id != undefined
                  ? a.text.localeCompare(b.text)
                  : 0
              ),
          })
          .on("select2:select", function (e) {
            $(this).attr("data-id", $(this).val());
            let input = $(this).parent("div").find("input");

            $(input).val($(this).val()).focus().blur();
            $(this).focus();

            closeSelect2OpenContainer();
          });
      }
    });
  }
}

function loadSelect2Num(obj = null, status = false) {
  if (obj != null) {
    $(obj).each(function (i, el) {
      if (!$(el).hasClass("select2-hidden-accessible")) {
        $(el)
          .select2({
            selectOnClose: true,
          })
          .on("select2:select", function (e) {
            $(this).attr("data-id", $(this).val());
            let input = $(this).parent("div").find("input");

            $(input).val($(this).val()).focus().blur();
            $(this).focus();

            closeSelect2OpenContainer();
          });
      }
      $(el).prop("enable", [status]);
    });
  }
}

function loadSelect2MultipleWithCheck(className, placeholder = "") {
  $(className)
    .multiselect({
      includeSelectAllOption: true,
      enableFiltering: true,
      enableCaseInsensitiveFiltering: true,
      buttonWidth: "160px",
      numberDisplayed: 0,
      selectedTop: true,
    })
    .on("change", function (e) {
      let latestData = $(e.target).val().join(",");
      $(this).parent().parent("div").find(".multiCheckVal").val(latestData);
      $(this).parent().parent("div").find(".multiCheckVal").trigger("focus");
      $(this).parent().parent("div").find(".multiCheckVal").trigger("blur");

      $(this).trigger("focus");
    });
}

function clearSelect2MultipleWithCheck(className) {
  setTimeout(() => {
    $(className).multiselect(
      "select",
      $(className).parent().parent("div").find(".multiCheckVal").val()
    );
    $(className).multiselect("refresh");
  }, 200);
  // $(className).trigger("change");
}

function setSelect2MultipleWithCheck(className, value) {
  // var newVal = value.split(',');
  // newVal = newVal.filter(function (item) { return parseInt(item); });
  // $(className).multiselect('select', value);
  // $(className).multiselect('refresh');
}

function formatSelection(state) {
  return state.text;
}

function formatResult(state) {
  if (!state.id) return state.text; // optgroup
  var id = "state_ws_" + state.id.toLowerCase();

  var string = "";
  if (state.selected) {
    string =
      '<div class="custom-control custom-checkbox"><input type="checkbox" id="' +
      id +
      '" class="custom-control-input" checked><label for="' +
      id +
      '" class="custom-control-label">' +
      state.text +
      "</label></div>";
  } else {
    string =
      '<div class="custom-control custom-checkbox"><input type="checkbox" id="' +
      id +
      '" class="custom-control-input"><label for="' +
      id +
      '" class="custom-control-label">' +
      state.text +
      "</label></div>";
  }
  // var label = $('<label for="' + id + '" class="custom-control-label"></label>')
  //   .text(state.text);
  // var checkbox = $('<input type="checkbox" id="' + id + '" class="custom-control-input">');

  // if (state.selected) {
  //   $('#' + id).attr('checked', 'checked');
  // }
  // return checkbox.add(label);
  return $(string);
}

function disableFields(className) {
  $(className).attr("disabled", "true");
}

function enableFields(className) {
  $(className).removeAttr("disabled");
}

function triggerChange(obj) {
  setTimeout(() => {
    $(obj).trigger("change");
  }, 100);
}

function triggerChangeWithValue(obj) {
  setTimeout(() => {
    $(obj).val("null").trigger("change");
  }, 100);
}

function triggerClick(obj) {
  $(obj).prop("checked", true);
}

function loadCheckedOnEnter() {
  $('input[type="checkbox"]').on("keypress", function (event) {
    if (event.which === 13) {
      this.checked = !this.checked;
    }
  });
}

function clearFile(obj) {
  $(obj).val("");
}

function setAttributeAndValue(elem, attr, value) {
  $(elem).attr(attr, value);
}

function setAttribute() {
  setTimeout(() => {
    $(".data_order").each(function () {
      $(this).attr("data-order", $(this).attr("id"));
      $(this).data("order", $(this).attr("id"));
    });
  }, 500);
}

function sortTM() {
  console.log("clicked");
}

function loadInputFormControlError(obj, action = "add") {
  if (action == "add") {
    $(obj).addClass("ng-touched ng-invalid");
    $(obj).removeClass("ng-valid");
  } else if (action == "remove") {
    $(obj).addClass("ng-touched ng-valid");
    $(obj).removeClass("ng-invalid");
  } else if (action == "removeAll") {
    $(obj).removeClass("ng-invalid ng-valid ng-touched");
  }
}

function loadDatePicker(className = "", altField = "") {
  if (className != "") {
    $(className)
      .datepicker({
        format: "mm/dd/yyyy",
        // todayBtn: "linked",
        autoclose: true,
        todayHighlight: true,
      })
      // .on('keydown', function (e) {
      //   if (e.keyCode == 9) {
      //     console.log($(className).datepicker().getDate());
      //   }
      // })
      .on("changeDate", function (e) {
        // console.log($(this).val());
        // $(this).change();
        // $(this).datepicker('setDate', $(this).val());
        // console.log("changed")
        if (altField != "") {
          $(altField).val($(this).val());
          $(altField).trigger("focus");
          // setTimeout(() => {
          $(altField).trigger("blur");
          $(this).trigger("focus");
          $(this).trigger("blur");
          $(this).datepicker("hide");
          // }, 1);
        } else {
          // $(this).trigger('focus');
          // setTimeout(() => {
          //   $(this).trigger('blur');
          // }, 100);
        }
      });
  } else {
    $(".datepicker")
      .datepicker({
        useCurrent: true,
        ignoreReadonly: true,
        format: "mm/dd/yyyy",
        todayBtn: "linked",
        autoclose: true,
        todayHighlight: true,
      })
      .on("changeDate", function (e) {
        // $(this).change();
        // $(this).datepicker('setDate', $(this).val());
        $(this).trigger("focus");
        setTimeout(() => {
          $(this).trigger("blur");
          $(this).datepicker("hide");
        }, 10);
      });
  }
}

function loadSelect2Error() {
  $(".error").each(function () {
    if ($(this).parent().find("select").hasClass("ng-invalid")) {
      $(this).parent().find(".select2-selection--single").addClass("error");
    } else {
      $(this).parent().find(".select2-selection--single").removeClass("error");
    }
  });
}

function clearForm(obj) {
  $(obj).trigger("reset");
  $("select").trigger("change");
}

function loadFocus() {
  // Set modal form input to autofocus when autofocus attribute is set
  $(".modal").on("shown.bs.modal", function () {
    $(this).find($.attr("autofocus")).focus();
  });
}

(function ($) {
  $.fn.extend({
    donetyping: function (callback, timeout) {
      timeout = timeout || 1500; // 1 second default timeout
      var timeoutReference,
        doneTyping = function (el) {
          if (!timeoutReference) return;
          timeoutReference = null;
          callback.call(el);
        };
      return this.each(function (i, el) {
        var $el = $(el);
        // Chrome Fix (Use keyup over keypress to detect backspace)
        // thank you @palerdot
        $el.is(":input") &&
          $el
            .on("keyup keypress paste", function (e) {
              // This catches the backspace button in chrome, but also prevents
              // the event from triggering too preemptively. Without this line,
              // using tab/shift+tab will make the focused element fire the callback.
              if (e.type == "keyup" && e.keyCode != 8) return;

              // Check if timeout has been set. If it has, "reset" the clock and
              // start over again.
              if (timeoutReference) clearTimeout(timeoutReference);
              timeoutReference = setTimeout(function () {
                // if we made it here, our timeout has elapsed. Fire the
                // callback
                doneTyping(el);
              }, timeout);
            })
            .on("blur", function () {
              // If we can, fire the event since we're leaving the field
              doneTyping(el);
            });
      });
    },
  });
})(jQuery);

function doneSearchTyping() {
  $("#search").donetyping(function () {
    $("#searchData").trigger("focus");
    $("#searchData").trigger("blur");
    $("#search").trigger("focus");
  });
}

function loadAutoFocus(obj, isSelect = false) {
  // if (obj == '#owner_id') {
  setTimeout(() => {
    $(obj).parent().find(".select2-container").addClass("select2border");
    // $(obj).parent().find('.select2-container').addClass('select2 - container--default select2 - container--focus')
  }, 200);
  // }
  // if (isSelect) {
  //   // $(obj).select2('focus');
  //   // setTimeout(() => {
  //   //   // closeSelect2OpenContainer();
  //   // }, 100);

  // } else {
  //   $(obj).trigger('focus');
  // }
}

function setNextElementFocus() {
  // var rg1 = new RadioGroup(document.getElementById('rg1'));
  // rg1.init();
  // var rg2 = new RadioGroup(document.getElementById('rg2'));
  // rg2.init();
  $(".click-tab").on("focus", function (e) {
    // $(window).on('keyup', function (e) {
    //   var code = (e.keyCode ? e.keyCode : e.which);
    //   if (code == 9) {
    //     alert('I was tabbed!');
    //   }
    // });

    var tab = $(this).attr("tabindex");
    tab++;
    $("[tabindex='" + tab + "']").trigger("focus");

    // //add all elements we want to include in our selection
    // var focussableElements = 'a:not([disabled]), button:not([disabled]), input[type=radio]:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
    // console.log(document.activeElement);
    // if (document.activeElement && document.activeElement.form) {
    //   var focussable = Array.prototype.filter.call(document.activeElement.form.querySelectorAll(focussableElements),
    //     function (element) {
    //       //check for visibility while always include the current activeElement
    //       return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement
    //     });
    //   var index = focussable.indexOf(document.activeElement);

    //   if (index > -1) {
    //     console.log(index);
    //     var nextElement = focussable[index + 1] || focussable[0];
    //     nextElement.focus();
    //   }
    // }
  });
}

function loadtextAreaPlaceHolder() {
  var textAreas = document.getElementsByTagName("textarea");

  Array.prototype.forEach.call(textAreas, function (elem) {
    elem.placeholder = elem.placeholder.replace(/\\n/g, "\n");
  });
}

function clearHTMLforTag(obj, html) {
  $(obj).html("");
}

function appendHTMLtoTag(obj, html) {
  $(obj).append(html);
}

$(document).ready(function () {
  $("body").delegate("*", "focus blur", function () {
    var elem = $(this);
    setTimeout(function () {
      let tabindexData = elem.attr("tabindex");
      if (
        !elem.hasClass(".select2border") &&
        tabindexData != 1 &&
        tabindexData != 2 &&
        tabindexData != 100 &&
        tabindexData != 101
      ) {
        $(".select2border").removeClass("select2border");
      }
    }, 100);
  });

  $(
    "header.top-header .navbar .card .card-body, .sidebar-area, .scrollbar"
  ).scrollbar();

  loadSelect2();
  loadSelect2Num(".select2Num", true);

  $(".data-table").DataTable({
    info: false,
    searching: false,
    lengthChange: false,
    columnDefs: [
      {
        targets: -1,
        orderable: false,
      },
    ],
  });

  loadDatePicker();

  // setTimeout(() => {
  //   $(".datepicker").each(function () {
  //     $(this).datepicker('setDate', $(this).val());
  //   });
  // }, 1000);

  loadFocus();

  reloadMenu();

  // loadCheckedOnEnter();

  $(".fa-calendar-alt").click(function () {
    $(this).closest(".input-group").find('input[type="text"]').focus();
  });

  $("input:radio").focus(function () {
    $(this).addClass("radio-highlight");
  });

  $("input:radio").blur(function () {
    $(this).removeClass("radio-highlight");
  });

  $(".click-tab-initial").on("focus", function () {
    //add all elements we want to include in our selection
    var focussableElements =
      'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
    if (document.activeElement && document.activeElement.form) {
      var focussable = Array.prototype.filter.call(
        document.activeElement.form.querySelectorAll(focussableElements),
        function (element) {
          //check for visibility while always include the current activeElement
          return (
            element.offsetWidth > 0 ||
            element.offsetHeight > 0 ||
            element === document.activeElement
          );
        }
      );
      var index = focussable.indexOf(document.activeElement);
      if (index > -1) {
        var nextElement = focussable[index + 1] || focussable[0];
        nextElement.focus();
      }
    }
  });

  // $('#file-upload').on('shown.bs.modal', function () {
  //   var myDropzone = new Dropzone("#attachSchedule", {
  //     url: "/file/post",
  //     addRemoveLinks: true,
  //     createImageThumbnails: false,
  //     previewsContainer: '.dropzone-previews',
  //     previewTemplate: document.querySelector('#previewTpl').innerHTML,
  //     // addedfile: function (file) {
  //     //   console.log(file);
  //     // }
  //   });
  // });
});

$(document).on("focus", ".select2.select2-container", function (e) {
  if ($(this).hasClass("select2border")) {
    $(this).removeClass("select2border");
  }

  // if (!$(this).parent().find('select').hasClass('hide-focus')) {
  var isOriginalEvent = e.originalEvent; // don't re-open on closing focus event
  var isSingleSelect = $(this).find(".select2-selection--single").length > 0; // multi-select will pass focus to input
  if (isOriginalEvent && isSingleSelect) {
    $(this).siblings("select:enabled").prop("open");
  }
  // }
});

function closeSelect2OpenContainer() {
  // var isOriginalEvent = e.originalEvent // don't re-open on closing focus event
  // var isSingleSelect = $('.select2.select2-container').find(".select2-selection--single").length > 0 // multi-select will pass focus to input

  // if (isOriginalEvent && isSingleSelect) {
  $(".select2.select2-container").siblings("select:enabled").prop("close");
  //}
}

function loadInvoiceDataOnScroll() {
  $(window).scroll(function () {
    if (
      $(window).scrollTop() == $(document).height() - $(window).height() &&
      $("#invoiceTable").height() > $(window).height()
    ) {
      // $('.invoiceLoadMoreData').click();
    }
  });
}

function addCollapseListeners() {
  $(".collapse").each((i, el) => {
    // execute this when the element is starting to expand
    $(el).on("show.bs.collapse", function (e) {
      const jobId = el.id.substring(el.id.lastIndexOf("-") + 1);
      document
        .getElementById(`note-list-${jobId}`)
        .dispatchEvent(refreshChatEvent);
      $(".collapse.show").collapse("hide"); // hide other open detail rows

      // change background color of selected row and add padding to details row
      $(e.target)
        .parent()
        .parent()
        .prev("tr")
        .toggleClass("expandedRow selectedRow");

      $("#invoiceTable").animate(
        { scrollTop: $(e.target).offset().top + 1000 },
        700
      );
    });

    // execute this when the element is starting to collapse
    $(el).on("hide.bs.collapse", function (e) {
      // this eliminates padding on the details row
      $(e.target).parent().parent().prev("tr").toggleClass("expandedRow");
    });

    // execute this when the element is finished collapsing
    $(el).on("hidden.bs.collapse", function (e) {
      // remove the background color of the selected row
      $(e.target).parent().parent().prev("tr").toggleClass("selectedRow");
    });

    // execute this when the element is finished expanding
    $(el).on("shown.bs.collapse", function (e) {
      // calc height of details row and determine if in view, if not, scroll
      let bottomOfElement =
        $(e.target).offset().top + $(e.target).outerHeight();
      let bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
      if (bottomOfElement > bottomOfScreen) {
        document.querySelector(".collapse.show").scrollIntoView(false);
      }
    });
  });
}
